<template>
  <md-dialog class="first-img-dialog" :md-closed="closeDialog" :md-opened="openDialog" :md-close-on-esc="false"
    :md-click-outside-to-close="false" :md-active.sync="options.showFirstImageForm">


    <md-dialog-content v-if="renderComp">
      <md-dialog-title class="first-img-title">
          <div class="tab-header-grid">
            <div class="tab-title">
          {{options.Lang.Titelbild_anpassen}}
            </div>
            <div class="tab-info-box">
              <SmallInfoBox title="Angebot" :content="tripAlias" />
            </div>

            <div class="tab-info-box">
              <SmallInfoBox :title="'Nezasa ID'" :content="trip.nezasa_id" :copy="true" />
            </div>
          </div>
        </md-dialog-title>
      <section v-if="options.isUploading" class="loading_spinner">
        <div v-if="options.isUploading" class="ladebalken">
          <div class="custom-spinner"></div>
        </div>
      </section>
      <div class="first-img-content">
        <div class="md-layout-item left-col">
          <p class="current-title-label">{{ options.Lang.Aktuelles_Titelbild }}</p>
          <div class="chosen-img-wrapper" v-if="titelimg">
            <img class="chosenimg" :src="'./' + titelimg" loading="lazy">
          </div>
          <div class="chosen-img-caption" v-if="titelimgName">{{ titelimgName }}</div>
          <div v-if="!titelimg">{{ options.Lang.kein_Titelbild }}</div>
        </div>

        <div class="md-layout-item right-col">
          <div class="right-col-header">
            <p style="font-size: 18px; margin: -1px;">{{options.Lang.neues_Bild_auswählen}}</p>
            <md-field class="right-col-field-select">
              <md-select v-model="selectedCat" @md-selected="loadImagesForCat()" name="selectedCat" id="selectedCat">
                <md-option v-for="(cat, index) in categories " :key="'index' + index" :value="cat.name">
                  {{ cat.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="right-col-scroll">
            <div class="imgContainer" v-if="imgsCat.length > 0">
            <div v-for="(img, index) in imgsCat" :key="img.img">
              <img
                  class="imgbgchoice"
                  :src="'./titleImgs/thumbs/' + img.img.replace('titleImgs/', '')"
                  @error="onImageError($event, img.img)"
                  loading="lazy"
                  width="129"
                  height="85"
              />
              <div style="display: flex; justify-content: center; margin-top: -13px;">
                <div class="imgSelected" @click="selectNew(img)">
                  <img v-if="img.img === titelimg" class="check-icon" :src="checkIcon" width="13" />
                </div>
              </div>
              <div class="first-img-pic-name">{{img.imageName}}</div>

              <md-tooltip v-if="img?.name" md-delay="300" md-direction="bottom">
                {{ img.imageName }}
              </md-tooltip>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="md-layout-item tab-actions-border">
        <md-button tabindex="8" class="md-raised secondary" @click="closeDialog">
          <strong>{{ options.Lang.Fenster_schließen }}</strong>
        </md-button>
      </div>
      <Error style="z-index: 11111;" class="errorDialog" v-if="options.showError && options.user.loggedIn" :options="options"></Error>
      <div class="editCat" v-if="showLastQuestion">
          <div class="contentEdit2 md-elevation-10">
            <div class="md-layout-item">
                <p>{{ options.Lang.Bild_löschen }}</p>
                <div style="float: right;">
                  <md-button tabindex="8" class="md-raised secondary" @click="closeQuestion()"><strong>{{options.Lang.Fenster_schließen}}</strong></md-button>
                </div>
            </div>
        </div>
      </div>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import * as moment from 'moment'
import { validationMixin } from 'vuelidate'
import Error from './Error.vue'
import Delete from './Delete.vue'
import SmallInfoBox from '@/components/parts/SmallInfoBox.vue'

export default {
  name: 'formFirstImage',
  mixins: [validationMixin],
  components: {
    SmallInfoBox,
    Error,
    Delete
    //SuccessHtml
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    currentTrip: {
      type: Object
    },
  },
  watch: {
    selectedCat(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.loadImagesForCat();
      }
    }
  },
  data: () => ({
    renderComp: false,
    selectedCat: null,
    categories: [],
    defaultCategory: null,
    imgsCat: [],
    myImg: null,
    showLastQuestion: false,
    showDelete: false,
    trip: null,
    titelCount: null,
    tripAlias: null,
    imgs: [],
    titelimg: null,
    titelimgName: null,
    newImg: null,
    checkIcon: require('../../assets/images/checkmark-icon-green.svg'),
  }),
  created() {
  },
  async mounted() {
    this.options.isUploading = true;
    this.trip = this.currentTrip;
    let test = await this.loadJsonField('trip_details');
    this.tripAlias = test.data.attributes.alias;

    try {
      await this.getAllCats();
      await this.getAllImg();
      await this.getTitleImg();

      // Set selectedCat only after categories are loaded
      this.selectedCat = this.defaultCategory ||
          (this.categories.length > 0 ? this.categories[0].name : null);

      // Always load images for the selected category
      this.loadImagesForCat();
    } catch (err) {
      console.error("Error loading data:", err);
    } finally {
      this.options.isUploading = false;
    }
  },
  methods: {
    async loadJsonField(key) {
      const trip = this.currentTrip ? this.currentTrip : null;
      const jsonPath = trip.json_path;

      const payload = {
        data: {
          file_path: jsonPath,
          key: key
        }
      };

      let self = this;

      return new Promise(resolve => {
        this.doPost(payload, 'json/findFieldInJsonFile', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
            return resolve(null);
          }
          resolve(res.data.value);   // return extracted JSON field
        });
      });
    },
    async getAllCats() {
      let self = this;
      self.doPost({}, 'getAllCategoriesToImages', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          self.categories = result;
          self.defaultCategory = result.find(cat => cat.defaultCat === "true")?.name || null;
          self.selectedCat = self.defaultCategory || (self.categories.length > 0 ? self.categories[0].name : null);
          self.renderComp = true;
          self.loadImagesForCat();
        }
      });
    },
    openDialog(){
      // This method is called when the dialog is opened
    },
    onImageError(event, fallbackPath) {
      event.target.src = './' + fallbackPath;
    },
    loadImagesForCat() {
      this.options.isUploading = true;
      this.imgsCat = [];

      if (this.selectedCat && this.imgs.length > 0) {
        this.imgs.forEach(pic => {
          if (pic.categorie === this.selectedCat) {
            this.imgsCat.push(pic);
          }
        });
      }

      this.options.isUploading = false;
    },
    closeDialog() {
      this.options.showFirstImageForm = false;
      this.options.currentTrip = null;
    },
    async getAllImg() {
      let self = this;
      self.options.isUploading = true;
      self.imgs = [];
      let tripId = self.trip.offer_id;
      return new Promise((resolve) => {
        self.doPost({ data: tripId }, 'getFirstImages', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            let result = res.data.data;
            for (let i = 0; i < result.length; i++) {
              self.imgs.push(result[i]);
            }
          }
          self.options.isUploading = false;
          resolve();
        });
      });
    },
    async selectNew(img) {
      this.options.isUploading = true;
      this.titelimg = img.img;
      this.titelimgName = img.imageName;
      let self = this;
      let uploadData = {
        id: self.trip.offer_id,
        img: self.titelimg,
      }
      await self.doPost({ data: uploadData }, 'savetitelImg', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.selectedCat = img.categorie
          self.options.currentTrip.titelimg = self.titelimg;
        }
      });
      await this.setPdfStatus();
      this.options.isUploading = false;
    },
    /**TODO Make sense of this function BK*/
    async setPdfStatus(){
      let data = {
        tripId : this.trip.nezasa_id,
        status : "false"
      }
      await this.doPost({ data: data }, 'setStatusPdf', function (res) {
            if (res.data.status === 'error') {
              self.help.log(self.$t(res.msg), false, true);
            }

          });
    },
    closeQuestion(){
      this.showLastQuestion = false;
    },
    getTitleImg() {
      let self = this;
      self.doPost({ data: self.trip.offer_id }, 'gettitelImg', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.titelimg = res.data.data[0].titelimg;
          self.titelimgName = res.data.data[0].imageName;
          self.selectedCat = self.defaultCategory;
        }
      });
    },
    getUploadImg(event) {
      this.newImg = event.target.files[0];
      
    },
    async rmvImgCheck(img){
      this.myImg = img;
      let self = this;
      await self.doPost({ data: img.img }, 'rmvImgCheck', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data.length
          if(result > 0){
            if(self.options.Lang == self.options.German){
              self.showErrorMsg(self.options.Lang.Bildnutzung)
            }else{
              self.showErrorMsg(self.options.Lang.Bildnutzung)
            }
          }else{
            self.showLastQuestion = true;
          }
        }
      });
     
    },
    async rmvImg() {
      let self = this;
      await self.doPost({ data: self.myImg.id }, 'rmvImg', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        }
      });
      await self.doPost({ data: self.myImg.img }, 'rmvImgFromTrip', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.getAllImg();
        }
      });
      await self.doPost({ data: self.myImg.img }, 'rmvFirstImage', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.getAllImg();
        }
      });
      self.showLastQuestion = false;
      self.getTitleImg();
    },
    async uploadImg() { 
      let self = this;

      await self.doPost({}, 'getglobalinfo', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data[0];
          self.titelCount = result.titelCount;
        }
      })
      if (self.newImg == null) {
        self.refreshDialog();
      }
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });

      async function Main(blub) {
        self.options.isUploading = true;
        const file = blub;
        let baseFile = await toBase64(file);

        //hier noch den pfad für db angeben
        let puffer = self.newImg.type.split("/");

        let uploadData = {
          nezasaId: self.trip.nezasa_id,
          file: baseFile,
          tripId: self.trip.offer_id,
          imgName: 'hero' + self.titelCount + "." + puffer[1],
          name: self.newImg.name
        }
        uploadData.dir = 'titleImgs/' + uploadData.imgName,
        self.doPost({data: uploadData}, 'uploadFirstImage', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.updateCounter();
          }
        });
      }

      if (this.newImg == "" || this.newImg == null) {
        this.options.isUploading = false;
        if(self.options.Lang == self.options.German){
              self.showErrorMsg(self.options.Lang.neues_Bild_auswählen)
            }else{
              self.showErrorMsg(self.options.Lang.neues_Bild_auswählen)
            }
      } else {
        Main(this.newImg);
      }
    },
    updateCounter(){
      let self = this;
      let updateData = {
              titelCount: self.titelCount + 1
            }
            self.doPost({ data: updateData }, 'updateTitelCount', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.refreshDialog();
        }
      });
    },
    
    refreshDialog() {
      let self = this;
      self.options.showFirstImageForm = false;
      self.$nextTick(() => {
        self.options.showFirstImageForm = true;
      });
    },
    moment(date) {
      return moment(date)
    }
  },
}
</script>
<style lang="scss">
@use '../../assets/style/General/tab_layout.scss';
.editCat{
  z-index: 111111;
  top: 0;
  left: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: transparent;
  overflow-y: hidden;
}
.bgEdit{
  background-color: rgb(94, 94, 94);
  padding-top: 1rem;
  padding-bottom: 1rem;
  height: 100%;
  width: 100%;
  opacity: 0.5;
}

.contentEdit2{
  position: absolute;
  top: 35%;
  padding: 3rem;
  background-color: white;
  width: 90%;
  height: 13rem;
  left: 5%;
}
.imgRemove {
  margin-top: 5px;
  background-color: rgb(253, 217, 223);
  text-align: center;
}
.right-col {
  margin-right: 20px;
}
.imgRemove:hover {
  cursor: pointer;
}

.imgbgchoice {
  width: 180px;
  height: 120px !important;
}

.chosenimg {
  width: 400px;
  height: 250px !important;
}

.dialog {
  width: 100%;
}

.imgContainer {
  display: grid !important;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;

}

.imgContainer img:hover {
  cursor: pointer;
}

.showMail {
  position: absolute;
  min-width: 900px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  background: white;
  padding: 50px;
  overflow-y: auto;
}

.tableclass {
  width: 100%;
  min-height: 70px;
  padding: 5px 5px;
  vertical-align: bottom;
  border-collapse: collapse;
}

.tableclass:hover {
  cursor: pointer;
}

.tableclass2 {
  width: 100%;
  min-height: 30px;
  padding: 5px 5px;
  vertical-align: bottom;
  border-collapse: collapse;

}

.tableclass td {
  padding: 5px;
  vertical-align: top;
}

.tableclass2 td {
  padding: 5px;
  vertical-align: top;
}

.tableclass tr {
  padding: 5px;
  background-color: rgb(243, 243, 243);
}

.spacer {
  background-color: white;
  height: 5px;
}

.name {
  width: 10%;
}

.date {
  width: 10%;
}

.trip-details {
  width: 30%;
}

.address1 {
  width: 15%;
}

.address2 {
  width: 20%;
}

.cc {
  width: 15%;
}

.minH {
  min-height: 50px;
}

.none {
  display: none;
}

.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #B6D210;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #B6D210 transparent transparent transparent;
}

.catTR td {
  background-color: white;
}

.choose-file::file-selector-button {
  font-weight: bold;
  color: #202224;
  font-family: "Nunito", sans-serif !important;
  font-size: 14px !important;
  background-color: #E1E8F3;
  padding: 10px 24px;
  outline: none;
  border: none;
  border-radius: 10px;
  width: 155px;
  height: 38px;
  display: inline-block;
  margin-top: 8px;
}
.choose-file::file-selector-button:hover{
 cursor:pointer;
 background-color: #c9cbce;
}

.imgSelected {
  border: 0.6px solid #A6A6A6;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  z-index: 5;
}

.deleteImg {
  border: 0.6px solid #A6A6A6;
  background-color: #FFFFFF;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  z-index: 5;
  margin-left: 15px;

}
.first-img-dialog .md-dialog-container{
  max-width: 1500px !important;
  width: 1500px !important;
  margin: auto;
}
.first-img-title{
  display: block;
  width: 100%;
  border-bottom: 1px #E1E8F3 solid !important;
  padding-bottom: 10px;
}
.first-img-content{
  height: 700px;
  margin: 20px 40px 20px 40px;
  display: grid;
  grid-template-columns: 30% 70%;
  column-gap: 40px;
  margin-bottom: 30px;
  margin-top: 30px;
}
.right-col-field-select{
  margin-bottom: 20px !important;
  overflow-y: auto;
}
.first-img-pic-name{
  width: 1 00%;
  text-align: center;
}
.left-col {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.current-title-label {
  font-size: 18px;
  margin-bottom: 15px;
}

/* The actual image */
.chosenimg {
  width: 100%;       /* same proportions as your screenshot */
  height: auto;
  object-fit: cover;
  display: block;
}

/* Caption box under the image */
.chosen-img-caption {
  background: #F1FEE7; /* soft green-ish like your screenshot */
  padding: 12px 18px;
  height: 70px;
  font-size: 18px;
  border-radius: 4px;
  width: 100%;
}

/* This part scrolls */
.right-col-scroll {
  flex: 1;
  overflow-y: auto;
  padding-right: 10px;
  height: 615px;
}
</style>